'use client';
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Hide: function Hide() {
    return _Hide;
  },
  Show: function Show() {
    return _Show;
  },
  useBreakpoint: function useBreakpoint() {
    return _useBreakpoint;
  },
  useBreakpointValue: function useBreakpointValue() {
    return _useBreakpointValue;
  },
  useColorModePreference: function useColorModePreference() {
    return _useColorModePreference;
  },
  useMediaQuery: function useMediaQuery() {
    return _useMediaQuery;
  },
  usePrefersReducedMotion: function usePrefersReducedMotion() {
    return _usePrefersReducedMotion;
  },
  useQuery: function useQuery() {
    return _useQuery;
  }
});

module.exports = __toCommonJS(src_exports); // src/media-query.tsx

var import_system = require("@chakra-ui/system");

var getBreakpoint = function getBreakpoint(theme, value) {
  var _a, _b;

  return (_b = (_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) != null ? _b : value;
};

function _useQuery(props) {
  var _props$breakpoint = props.breakpoint,
      breakpoint = _props$breakpoint === void 0 ? "" : _props$breakpoint,
      below = props.below,
      above = props.above;
  var theme = (0, import_system.useTheme)();
  var bpBelow = getBreakpoint(theme, below);
  var bpAbove = getBreakpoint(theme, above);
  var query = breakpoint;

  if (bpBelow) {
    query = "(max-width: ".concat(bpBelow, ")");
  } else if (bpAbove) {
    query = "(min-width: ".concat(bpAbove, ")");
  }

  return query;
} // src/use-media-query.ts


var import_react_env = require("@chakra-ui/react-env");

var import_react = require("react");

function _useMediaQuery(query) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$ssr = options.ssr,
      ssr = _options$ssr === void 0 ? true : _options$ssr,
      fallback = options.fallback;

  var _ref = (0, import_react_env.useEnvironment)(),
      getWindow = _ref.getWindow;

  var queries = Array.isArray(query) ? query : [query];
  var fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter(function (v) {
    return v != null;
  });

  var _ref2 = (0, import_react.useState)(function () {
    return queries.map(function (query2, index) {
      return {
        media: query2,
        matches: ssr ? !!fallbackValues[index] : getWindow().matchMedia(query2).matches
      };
    });
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      value = _ref3[0],
      setValue = _ref3[1];

  (0, import_react.useEffect)(function () {
    var win = getWindow();
    setValue(queries.map(function (query2) {
      return {
        media: query2,
        matches: win.matchMedia(query2).matches
      };
    }));
    var mql = queries.map(function (query2) {
      return win.matchMedia(query2);
    });

    var handler = function handler(evt) {
      setValue(function (prev) {
        return prev.slice().map(function (item) {
          if (item.media === evt.media) return _objectSpread(_objectSpread({}, item), {}, {
            matches: evt.matches
          });
          return item;
        });
      });
    };

    mql.forEach(function (mql2) {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return function () {
      mql.forEach(function (mql2) {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [getWindow]);
  return value.map(function (item) {
    return item.matches;
  });
} // src/visibility.tsx


function Visibility(props) {
  var breakpoint = props.breakpoint,
      hide = props.hide,
      children = props.children,
      ssr = props.ssr;

  var _useMediaQuery2 = _useMediaQuery(breakpoint, {
    ssr: ssr
  }),
      _useMediaQuery3 = _slicedToArray(_useMediaQuery2, 1),
      show = _useMediaQuery3[0];

  var isVisible = hide ? !show : show;
  var rendered = isVisible ? children : null;
  return rendered;
} // src/hide.tsx


var import_jsx_runtime = require("react/jsx-runtime");

function _Hide(props) {
  var children = props.children,
      ssr = props.ssr;

  var query = _useQuery(props);

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(Visibility, {
    breakpoint: query,
    hide: true,
    ssr: ssr,
    children: children
  });
}

_Hide.displayName = "Hide"; // src/media-query.hook.ts

function _usePrefersReducedMotion(options) {
  var _useMediaQuery4 = _useMediaQuery("(prefers-reduced-motion: reduce)", options),
      _useMediaQuery5 = _slicedToArray(_useMediaQuery4, 1),
      prefersReducedMotion = _useMediaQuery5[0];

  return prefersReducedMotion;
}

function _useColorModePreference(options) {
  var _useMediaQuery6 = _useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options),
      _useMediaQuery7 = _slicedToArray(_useMediaQuery6, 2),
      isLight = _useMediaQuery7[0],
      isDark = _useMediaQuery7[1];

  if (isLight) return "light";
  if (isDark) return "dark";
  return void 0;
} // src/show.tsx


var import_jsx_runtime2 = require("react/jsx-runtime");

function _Show(props) {
  var children = props.children,
      ssr = props.ssr;

  var query = _useQuery(props);

  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(Visibility, {
    breakpoint: query,
    ssr: ssr,
    children: children
  });
}

_Show.displayName = "Show"; // src/use-breakpoint.ts

var import_system2 = require("@chakra-ui/system");

var import_shared_utils = require("@chakra-ui/shared-utils");

function _useBreakpoint(arg) {
  var _a, _b;

  var opts = (0, import_shared_utils.isObject)(arg) ? arg : {
    fallback: arg != null ? arg : "base"
  };
  var theme = (0, import_system2.useTheme)();

  var breakpoints = theme.__breakpoints.details.map(function (_ref4) {
    var minMaxQuery = _ref4.minMaxQuery,
        breakpoint = _ref4.breakpoint;
    return {
      breakpoint: breakpoint,
      query: minMaxQuery.replace("@media screen and ", "")
    };
  });

  var fallback = breakpoints.map(function (bp) {
    return bp.breakpoint === opts.fallback;
  });

  var values = _useMediaQuery(breakpoints.map(function (bp) {
    return bp.query;
  }), {
    fallback: fallback,
    ssr: opts.ssr
  });

  var index = values.findIndex(function (value) {
    return value == true;
  });
  return (_b = (_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) != null ? _b : opts.fallback;
} // src/use-breakpoint-value.ts


var import_system3 = require("@chakra-ui/system");

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_breakpoint_utils2 = require("@chakra-ui/breakpoint-utils"); // src/media-query.utils.ts


var import_breakpoint_utils = require("@chakra-ui/breakpoint-utils");

function getClosestValue(values, breakpoint) {
  var breakpoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : import_breakpoint_utils.breakpoints;
  var index = Object.keys(values).indexOf(breakpoint);

  if (index !== -1) {
    return values[breakpoint];
  }

  var stopIndex = breakpoints.indexOf(breakpoint);

  while (stopIndex >= 0) {
    var key = breakpoints[stopIndex];

    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }

    stopIndex -= 1;
  }

  if (index !== -1) {
    var _key = breakpoints[index];
    return values[_key];
  }

  return void 0;
} // src/use-breakpoint-value.ts


function _useBreakpointValue(values, arg) {
  var _a;

  var opts = (0, import_shared_utils2.isObject)(arg) ? arg : {
    fallback: arg != null ? arg : "base"
  };

  var breakpoint = _useBreakpoint(opts);

  var theme = (0, import_system3.useTheme)();
  if (!breakpoint) return;
  var breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  var obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0, import_breakpoint_utils2.arrayToObjectNotation)(values, breakpoints)).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return [key, value];
  })) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
} // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  Hide: _Hide,
  Show: _Show,
  useBreakpoint: _useBreakpoint,
  useBreakpointValue: _useBreakpointValue,
  useColorModePreference: _useColorModePreference,
  useMediaQuery: _useMediaQuery,
  usePrefersReducedMotion: _usePrefersReducedMotion,
  useQuery: _useQuery
});